import ThumbnailImage, {
  getThumbnailUrl,
} from '@flight-workspace/common-client/src/components/thumbnailImage';
import { nClick } from '@flight-workspace/common-client/src/util/nClick';
import classNames from 'classnames/bind';
import config from 'config/index';
import { SetStateAction, useEffect, useRef } from 'react';
import styles from './extraPhoto.module.scss';
import { areaCode } from './utils';

const cx = classNames.bind(styles);

declare global {
  interface Window {
    NAVER_MOBILE_VIEWER: any;
  }
}

const ExtraPhoto = ({
  imageList,
  airline,
  setIsPhotoClick,
}: {
  imageList: any;
  airline: string;
  setIsPhotoClick: React.Dispatch<SetStateAction<boolean>>;
}) => {
  const viewer: any = useRef(null);

  const addPhotoViewerLib = () => {
    viewer.current = new window.NAVER_MOBILE_VIEWER({
      animationAlign: 'center',
    });
    viewer.current
      .on('show', () => {
        const doc: any = document;
        if (doc) {
          doc.getElementById('container').style.display = 'none';
        }
      })
      .on('beforehide', () => {
        const doc: any = document;
        if (doc) {
          doc.getElementById('container').style.display = '';
        }
        setIsPhotoClick(false);
      })
      .on('back', (e: any) => {
        nClick(`${areaCode}.imageclose`, e);
      })
      .on('prev', (e: any) => {
        nClick(`${areaCode}..imageleft`, e);
      })
      .on('next', (e: any) => {
        nClick(`${areaCode}.imageright`, e);
      });
  };

  useEffect(() => {
    addPhotoViewerLib();
  }, []);

  const showPhotoViewer = () => {
    const itemList = imageList.map((item: any, idx: number) => {
      return {
        id: idx,
        no: idx + 1,
        imgUrl: getThumbnailUrl(config.thumbnail, item.ImageFileName, 'm1500'),
        // originalUrl: `https://search.pstatic.net/common/?src=${item.ImageFileName}`,
        title: `${airline}`,
      };
    });
    viewer.current.show({
      list: itemList,
      index: 0,
    });
    setIsPhotoClick(true);
  };

  return (
    <div
      className={cx('ExtraPhoto', '_item')}
      data-event-nlog="click"
      data-event-area-code={`${areaCode}.moreimage`}
      onClick={showPhotoViewer}
    >
      <a className={cx('anchor')} href="#">
        <figure className={cx('thumb')}>
          <ThumbnailImage
            className={cx('img', '_img', '_init_img')}
            alt=""
            data-height="597"
            data-width="478"
            thumbnail={config.thumbnail}
            src={imageList[0].ImageFileName}
            type="f180_216"
          />
        </figure>
        <span className={cx('txt')}>사진 {imageList.length}장</span>
      </a>
    </div>
  );
};

export default ExtraPhoto;
